import React from "react";
import { Outlet } from "react-router-dom";

const MainPullSheet = () => {
  return (
    <div>
      <div>
        <Outlet></Outlet>
      </div>
    </div>
  );
};

export default MainPullSheet;
